module.exports = __webpack_public_path__ + "static/media/problem-01.e19e9a69.png";